import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { HeaderFactory } from '../../common/HeaderFactory'
import { InstitutionModel } from '../models/InstitutionModel';

declare const OUTCOMES_API: string;

@Injectable()
export class InstitutionService {

    constructor(
        private http: Http,
        private headerFactory: HeaderFactory
    ) { }

    getList(): Observable<InstitutionModel[]> {        
        return this.http.get(OUTCOMES_API + '/institutions', {
            headers: this.headerFactory.make()
        }).map(res => res.json());
    }
}


/** WEBPACK FOOTER **
 ** ./app/institution/services/InstitutionService.ts
 **/